// extracted by mini-css-extract-plugin
module.exports = {"Date_component":"DateIcon_Date_component__1fzYM","NewsEvent_itemCalText":"DateIcon_NewsEvent_itemCalText__1a4eC"};